import { Badge, BadgeText } from "@repo/components/src/ui/badge";

import { lightenHex } from "@repo/components/src/utils/color";
import { ComponentProps } from "react";

interface TagBadgeProps {
  name: string;
  color: string;
  size?: ComponentProps<typeof Badge>["size"];
}

export default function TagBadge({ name, color, size = "sm" }: TagBadgeProps) {
  return (
    <Badge
      size={size}
      rounded="full"
      style={{
        backgroundColor: lightenHex(color, 0.8),
        borderColor: lightenHex(color, 0.3),
        borderWidth: 1,
      }}
      className="px-2 py-0.5"
    >
      <BadgeText style={{ color: color }}>{name}</BadgeText>
    </Badge>
  );
}
